import { render, staticRenderFns } from "./ClientAreasFilters.vue?vue&type=template&id=8010b824"
import script from "./ClientAreasFilters.vue?vue&type=script&lang=js"
export * from "./ClientAreasFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports